import { SIDEBAR_SET_CONTENT, SET_OPEN_SIDEBAR, SET_OPEN_DRAWER } from '../actions/sideBarActions';

const initial_state = {
  drawer: false,
  open: false,
  contentType: 'direction'
};

const sideBar = (state = initial_state, action) => {

  switch (action.type) {
    case SIDEBAR_SET_CONTENT:
      return {
        ...state,
        contentType: action.contentType
      };
    case SET_OPEN_SIDEBAR:
      return {
        ...state,
        open: action.open
      };
    case SET_OPEN_DRAWER:
      return {
        ...state,
        drawer: action.open
      };
    default:
      return state;
  }
};

export default sideBar;
